// When a support conversation put on hold comes back to "Needs staff". Plain functions with no
// database code, shared by the API (which decides) and the admin app (which shows the times).

/** Nepal Standard Time, UTC+05:45 all year (no daylight saving): the team's working day. */
const NEPAL_OFFSET_MS = (5 * 60 + 45) * 60_000;
const HOUR = 3600_000;

export const SNOOZE_PRESETS = ['1h', '4h', 'tomorrow', '3d'] as const;
export type SnoozePreset = (typeof SNOOZE_PRESETS)[number];

export const SNOOZE_LABELS: Record<SnoozePreset, string> = {
  '1h': '1 hour',
  '4h': '4 hours',
  tomorrow: 'Tomorrow, 10:00 Nepal time',
  '3d': '3 days',
};

/** The shortest and longest hold staff can set. */
export const SNOOZE_MIN_MS = 5 * 60_000;
export const SNOOZE_MAX_MS = 30 * 24 * HOUR;

/** 10:00 Nepal time on the day after today's date in Nepal, as epoch milliseconds. */
export function nextNepalMorning(now: number): number {
  const nepal = new Date(now + NEPAL_OFFSET_MS);
  return (
    Date.UTC(nepal.getUTCFullYear(), nepal.getUTCMonth(), nepal.getUTCDate() + 1, 10) -
    NEPAL_OFFSET_MS
  );
}

/** When a hold chosen now with `preset` ends. */
export function snoozeUntil(preset: SnoozePreset, now: number): number {
  switch (preset) {
    case '1h':
      return now + HOUR;
    case '4h':
      return now + 4 * HOUR;
    case 'tomorrow':
      return nextNepalMorning(now);
    case '3d':
      return now + 72 * HOUR;
  }
}

/** Why a custom end time can't be used, or null. */
export function snoozeError(until: number, now: number): string | null {
  if (!Number.isSafeInteger(until)) return 'Pick a date and time.';
  if (until < now + SNOOZE_MIN_MS) return 'Pick a time at least 5 minutes from now.';
  if (until > now + SNOOZE_MAX_MS) return 'A hold can last 30 days at most.';
  return null;
}
